<mat-form-field appearance="standard" class="field-full-width">
    <mat-label>Agendas</mat-label>
    <mat-select>
        <mat-option *ngFor="let agenda of agendaSrv.agendas" [value]="agenda" (click)="select(agenda)">
          {{agenda.group}} - {{agenda.agenda}}
        </mat-option>
    </mat-select>
</mat-form-field>